import queryString from "query-string";

/**
 * 
 * @param {boolen} parsed Si es true, retorna un objeto con los parámetros de consulta.
 * Si es false, retorna una cadena de consulta formateada.
 * @returns {string|object} Parámetros de consulta formateados como cadena o como objeto.
 * @description Obtiene los parámetros de consulta de la URL.
 * Extrae el ID del usuario, el ID del administrador y la fecha de inicio de sesión
 * del almacenamiento de sesión y los agrega a un objeto de parámetros de consulta.
 * Si parsed es true, retorna un objeto con los parámetros de consulta.
 * Si parsed es false, retorna una cadena de consulta formateada.
 * @author David Maldonado
 * @version 1.0.0
 */
export function getQueryParams(parsed = false) {
    const clienteUsuarioId = sessionStorage.getItem("user");
    const adminId = sessionStorage.getItem("admin_id");
    const fechaLogin = sessionStorage.getItem("fechaLogin");

    const queryParamsParsed = {};
    queryParamsParsed["cuid"] = clienteUsuarioId;
    queryParamsParsed["faid"] = fechaLogin;
    if (adminId) {
        queryParamsParsed["admid"] = adminId;
    }

    return parsed
        ? queryParamsParsed
        : queryString.stringify(queryParamsParsed);
}

/**
 * 
 * @param {string} pathname - Ruta del objeto de la URL
 * @param {} defaultParams - Parámetros de consulta por defecto
 * @description Retorna un objeto de ruta con los parámetros de consulta actualizados.
 * Combina los parámetros de consulta actuales con los parámetros por defecto y los parámetros de consulta obtenidos de la función `getQueryParams`.
 * @returns {object} Objeto de ruta con la URL y los parámetros de consulta actualizados.
 * @author David Maldonado
 * @version 1.0.0
 */
export function getRouteObject(pathname, defaultParams) {
    const querySearchPathname = queryString.parseUrl(pathname);
    const search = { ...querySearchPathname.query, ...getQueryParams(true), ...defaultParams };

    return {
        pathname: querySearchPathname.url,
        search: queryString.stringify(search),
    };
}
